import { OTHERS_OF_CVP } from 'omega-rtc/constants/ucd';
import {
  CVP_BASED_ON_VERTICAL_AND_COUNTRY_ID,
  CVP_DISPLAY_NAMES,
} from 'omega-rtc/data/smart-campaign';
import { CampaignTargetVerticals } from 'omega-rtc/data/trident-campaigns';

const verticalLabels = CampaignTargetVerticals;
const productOfferingLabels = CVP_DISPLAY_NAMES;

export const JOURNEY_CAMPAIGN_VERTICAL_OPTIONS = Object.entries(
  verticalLabels,
).map(([value, label]) => ({ label, value }));

export const getJourneyCampaignProductOfferingOptions = (vertical: string) => {
  if (!vertical) {
    return [];
  }

  const countryMappings = Object.values(
    CVP_BASED_ON_VERTICAL_AND_COUNTRY_ID,
  );
  const productOfferings = Array.from(new Set(
    countryMappings.flatMap((mapping) => mapping[vertical] || []),
  ));

  return [
    ...productOfferings.map((value) => ({
      label: productOfferingLabels[value] || value,
      value,
    })),
    { label: OTHERS_OF_CVP, value: OTHERS_OF_CVP },
  ];
};

export const getJourneyCampaignVerticalLabel = (vertical: string) => (
  verticalLabels[vertical] || vertical
);

export const getJourneyCampaignProductOfferingLabel = (
  productOffering: string,
) => productOfferingLabels[productOffering] || productOffering;
